
// Publishable keys (client-side)
export const WhichKey = (): string => {
  return process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY || '';
};

// Secret keys (server-side only)
export const WhichSecretKey = (): string => {
  // Check if running on actual production domain (sellwild.com)
  const isProduction = process.env.NEXT_PUBLIC_API_URL?.includes('sellwild.com') &&
                      !process.env.NEXT_PUBLIC_API_URL?.includes('new.sellwild.com') &&
                      !process.env.NEXT_PUBLIC_API_URL?.includes('dev.sellwild.com');

  return isProduction
    ? (process.env.STRIPE_SECRET_LIVE || '')
    : (process.env.STRIPE_SECRET_TEST || '');
};
